"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var StyledPrice = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));

exports.Price = function (_a) {
  var children = _a.children;
  return react_1.default.createElement(StyledPrice, null, children, " kr");
};

var templateObject_1;